<template>
  <unicom-layout-cartao semFiltro>
    <unicom-linha class="linha-embaixo">
      <unicom-coluna sm="12" style="padding-bottom: 24px">
        <div class="titulo negrito cor-fonte fonte-primaria">
          Atendimentos e Intercâmbio
        </div>
      </unicom-coluna>
    </unicom-linha>

    <unicom-linha
      style="margin-bottom: 24px"
      class="linha-embaixo"
      justificarItem="end"
    >
      <unicom-coluna sm="4" :class="espacamentoMobile">
        <div align="right">Atende Beneficiário de Intercâmbio?</div>
      </unicom-coluna>
      <unicom-coluna sm="1" :class="espacamentoMobile">
        <unicom-switch
          :value="clickSwitchAtendimento.atendeIntercambio"
          @input="
            clickSwitchAtendimento.atendeIntercambio = !clickSwitchAtendimento.atendeIntercambio
          "
          :inativo="true"
        />
      </unicom-coluna>
      <unicom-coluna sm="7" :class="espacamentoMobile"> </unicom-coluna>
    </unicom-linha>

    <unicom-linha class="linha-embaixo">
      <unicom-coluna sm="4" :class="espacamentoMobile">
        <div align="right">Atende Outros Convênios?</div>
      </unicom-coluna>
      <unicom-coluna sm="1" :class="espacamentoMobile">
        <unicom-switch
          :value="clickSwitchAtendimento.atendeOutrosConvenios"
          @input="toggleSwitch('atendeOutrosConvenios')"
        />
      </unicom-coluna>
      <unicom-coluna
        sm="5"
        :class="espacamentoMobile"
        v-if="clickSwitchAtendimento.atendeOutrosConvenios"
      >
        <unicom-campo-texto
          ladoIcone="direito"
          :maxCaracteres="1500"
          clickIcone
          colorPlaceholder="#9E9E9E"
          placeholder="Quais? *"
          v-model="atendimentoIntercambio.outrosConvenios"
          :mensagemErro="errors.campoOutrosConvenios"
        />
      </unicom-coluna>
      <unicom-coluna sm="2" :class="espacamentoMobile"> </unicom-coluna>
    </unicom-linha>

    <unicom-linha style="margin-bottom: 24px" justificarItem="end">
      <unicom-coluna sm="4" :class="espacamentoMobile">
        <div align="right">Atende Particular?</div>
      </unicom-coluna>
      <unicom-coluna sm="1" :class="espacamentoMobile">
        <unicom-switch
          :value="clickSwitchAtendimento.atendeParticular"
          @input="
            clickSwitchAtendimento.atendeParticular = !clickSwitchAtendimento.atendeParticular
          "
        />
      </unicom-coluna>
      <unicom-coluna sm="7" :class="espacamentoMobile"> </unicom-coluna>
    </unicom-linha>
  </unicom-layout-cartao>
</template>

<script>
import AtendimentoMixin from "@/views/RecursosPropriosQuestionarios/shared/mixins/questionarios/AtendimentoMixin";

export default {
  name: "CartaoInformacoesAtendimento",
  mixins: [AtendimentoMixin],
  components: {},
  props: {},
  data() {
    return {};
  },
  methods: {
    toggleSwitch(campo) {
      return (this.clickSwitchAtendimento[campo] = !this.clickSwitchAtendimento[
        campo
      ]);
    }
  },
  computed: {
    /**
     * Verifica se a tela está no viewport mobile e se estiver, retorna uma classe que da o espaçamento para cima
     */
    espacamentoMobile() {
      return this.$breakpoint.smAndDown ? "mt-4" : "";
    }
  },
  watch: {}
};
</script>

<style scoped>
.linha-embaixo {
  padding-bottom: 24px;
  border-bottom: 1px solid #ebebeb;
  margin-bottom: 24px;
}
</style>
